import axiosInstance from "../axios-instance";
import type { TaggingGuidanceResponse } from "./types";

/** 워크북 진입 시 강조할 다음 태깅 액션(롤포워드/오토태깅)을 가져온다. */
export const getTaggingGuidance = async (
  workbookId: string,
): Promise<TaggingGuidanceResponse> => {
  const response = await axiosInstance.get(
    `/v1/workbooks/${workbookId}/tagging-guidance`,
  );
  return response.data as TaggingGuidanceResponse;
};
